//  src/components/Utils/errorUtils.js
export const CartErrorMessages = {
    OVER_QUANTITY_LIMIT: "You tried to add more than what's available.",
    VARIATION_NOT_FOUND: "This product variation no longer exists.",
    INVALID_QUANTITY: "Quantity must be at least 1.",
    GENERAL_CART_ERROR: "Something went wrong while updating the cart.",
    INVALID_PRODUCT: "This item is not currently available for purchase.",
  };